import { render, staticRenderFns } from "./EditExamBigClass.vue?vue&type=template&id=a046aad8&scoped=true&"
import script from "./EditExamBigClass.vue?vue&type=script&lang=js&"
export * from "./EditExamBigClass.vue?vue&type=script&lang=js&"
import style0 from "./EditExamBigClass.vue?vue&type=style&index=0&id=a046aad8&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a046aad8",
  null
  
)

export default component.exports